import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import classes from "./PostDetail.module.scss";
import { PageTitle } from "../PageTitle/PageTitle";

// Postの型を更新
interface Post {
  id: number;
  title: { rendered: string };
  content?: { rendered: string };
  excerpt: { rendered: string };
  link: string;
  date: string; // 追加
  featured_media_url?: string;
  categories: number[];
}

const formatDate = (isoDate: string) => {
  const date = new Date(isoDate);
  return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
};


const PostDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [postData, setPostData] = useState<Post | null>(null);

  const categoryTitleMapping: { [key: number]: string } = {
    119: "導入校インタビュー",
    121: "HADO EDUCATIONの研究成果",
    // 他のカテゴリIDとタイトルのマッピング
  };

  const pageTitle = postData && postData.categories && postData.categories[0]
    ? categoryTitleMapping[postData.categories[0]] || "NEWS"
    : "NEWS";

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`https://hado-official.com/wp-json/wp/v2/posts/${id}?_embed`);
      const data = await response.json();

      if (data._embedded && data._embedded['wp:featuredmedia'] && data._embedded['wp:featuredmedia'][0]) {
        data.featured_media_url = data._embedded['wp:featuredmedia'][0].source_url;
      }

      setPostData(data);
    };

    fetchData();
  }, [id]);

  return (
    <div className={classes.root + ' contents' + ' postDetail'}>
      {postData?.link ? (
        <Helmet>
          <link rel="canonical" href={postData.link} />
        </Helmet>
      ) : null}
      <PageTitle title={pageTitle}/>

      <div className={classes.newsList + ' contentWidth'}>
      <div className={classes.postDate}>{postData?.date ? formatDate(postData.date) : ''}</div>
        <h1 className={classes.postTitle}>{postData?.title?.rendered}</h1>
        
        {postData?.featured_media_url && <img src={postData.featured_media_url} alt={postData?.title?.rendered || 'Featured Image'} className={classes.postImg} />}
        <div dangerouslySetInnerHTML={{ __html: postData?.content?.rendered || '' }} />
      </div>
    </div>
  );
};

export default PostDetail;
